import { CardRow, CardSection } from "tessa/cards";
import { TypedField, createTypedField, DotNetType } from "tessa/platform";

export class CdCommonHelper {

  public static SetFieldToRow(row: CardRow, fieldName: string, value: TypedField) {
    if (value == null) {
      row.set(fieldName, null);
    }
    else {
      row.set(fieldName, value);
    }
  }

  public static SetFieldToSection(section: CardSection, fieldName: string, value: TypedField) {
    if (value == null) {
      section.fields.set(fieldName, null);
    }
    else {
      section.fields.set(fieldName, value);
    }
  }

  public static SetValueToSectionField(section: CardSection, fieldName: string, value,  type: DotNetType) {
    if (value == null) {
      section.fields.set(fieldName, null);
    }
    else {
      section.fields.set(fieldName, createTypedField(value, type));
    }
  }

  public static SetValueToRowField(row: CardRow, fieldName: string, value,  type: DotNetType) {
    if (value == null) {
      row.set(fieldName, null);
    }
    else {
      row.set(fieldName, createTypedField(value, type));
    }
  }

}